import { LOCATION_CHANGE } from "react-router-redux";
import {
  LOADING_START,
  LOADING_STOP,
  MODAL_INIT,
  MODAL_OPEN,
  MODAL_CLOSE,
  HANDLE_ERRORS,
  CLEAR_ERRORS,
  NOTIFY_UPDATE,
  NOTIFY,
  CLEAR_NOTIFICATION,
  SET_UPLOAD_PROGRESS,
  SET_RCL_NOTIFICATION,
  OPEN_BANNER,
  CLOSE_BANNER,
  TOGGLE_BANNER
} from '../actionTypes';

import {
  USER_SIGN_OUT,
} from '../../user/actionTypes';

import {
  TRADE_DOCUMENTS_FETCH_SUCCESS,
  TRADE_DOCUMENTS_FETCH_FAILURE,
} from '../../trade_documents/actionTypes';

let initialState = {
  loading: {
    default: false,
  },
  modal: {
    default: false,
  },
  errors: {
    data: {},
    header: 'Oops, something went wrong',
    body: 'Error processing request',
    duration: 7,
    status: null,
    statusType: null,
  },
  notification: {
    open: false,
    header: '',
    body: '',
    duration: 3,
    className: '-primary',
    dismissable: true,
  },
  rcl_notification: {
    header: '',
    body: '',
    open: false,
    duration: -1,
    className: '-warning',
    dismissable: false,
  },
  maintenance_banner: {
    message: process.env.REACT_APP_MAINTENANCE_MSG,
    title: process.env.REACT_APP_MAINTENANCE_TITLE,
    expiry: process.env.REACT_APP_MAINTENANCE_EXPIRATION_DATE,
    open: false,
    dismissed: false
  },
  new_feature_banner: {
    message: process.env.REACT_APP_FEATURE_MSG,
    title: process.env.REACT_APP_FEATURE_TITLE,
    expiry: process.env.REACT_APP_FEATURE_EXPIRATION_DATE,
    open: false,
    dismissed: false
  },
  fc_connect_notification: {
    open: false,
    dismissed: false
  },
  uploadProgress: null,
  newVersion: false,
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case LOADING_START:
      let loadingStart = { ...state.loading };
      loadingStart[action.payload] = true;
      return { ...state, loading: loadingStart };
    case LOADING_STOP:
    case TRADE_DOCUMENTS_FETCH_SUCCESS:
    case TRADE_DOCUMENTS_FETCH_FAILURE:
      let loadingStop = { ...state.loading };
      loadingStop[action.payload] = false;
      return { ...state, loading: loadingStop };
    case MODAL_INIT:
      let initModal = { ...state.modal };
      initModal[action.payload.name] = action.payload.open;
      return { ...state, modal: { ...initModal } };
    case MODAL_OPEN:
      window.scrollTo(0, 0);
      let openModal = { ...state.modal };
      openModal[action.payload] = true;
      return { ...state, modal: { ...openModal } };
    case MODAL_CLOSE:
      let closeModal = { ...state.modal };
      closeModal[action.payload] = false;
      return { ...state, modal: { ...closeModal } };
    case HANDLE_ERRORS:
      if (!action.payload) return state;

      let updatedLoading = { ...state.loading };
      Object.keys(updatedLoading).forEach((loading) => {
        updatedLoading[loading] = false;
      });
      return {
        ...state,
        errors: { ...state.errors, ...action.payload },
        loading: updatedLoading,
      };
    case SET_UPLOAD_PROGRESS:
      return { ...state, uploadProgress: action.payload };
    case NOTIFY_UPDATE:
      return { ...state, newVersion: true };
    case USER_SIGN_OUT:
    case CLEAR_ERRORS:
      return { ...state, errors: initialState.errors };

    case NOTIFY:
      if (!!state.notification.open) return state;
      return {
        ...state,
        notification: { ...state.notification, ...action.payload, open: true },
      };
    case CLEAR_NOTIFICATION:
      if (!state.notification.open) return state;
      return { ...state, notification: initialState.notification };
    case LOCATION_CHANGE:
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'Pageview',
        pagePath: action.payload.pathname,
        pageTitle: action.payload.pathname,
      });
      window.scrollTo(0, 0);
      return { ...state, errors: initialState.errors };
    case SET_RCL_NOTIFICATION:
      if(typeof action.payload === 'object'){
        const { body, header } = action.payload
        const notification = {
          ...initialState.rcl_notification,
          open: true,
          body,
          header,
        };
        return { ...state, rcl_notification: notification };
      }
      const notification = {
        ...initialState.rcl_notification,
        open: true,
        body: action.payload,
      };
      return { ...state, rcl_notification: notification };
    case OPEN_BANNER:
      const bannerState = {
        ...initialState[action.payload],
        open: true
      };
      return { ...state, [action.payload]: bannerState };
    case CLOSE_BANNER:
      const closedBannerState = {
        ...initialState[action.payload],
        open: false,
        dismissed: true
      };
      return { ...state, [action.payload]: closedBannerState };
    case TOGGLE_BANNER:
      return { ...state, active_banner: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/shared/reducers/ui.js